<svg xmlns="http://www.w3.org/2000/svg"
     class="board"
     [attr.viewBox]="viewBoxString()"
     preserveAspectRatio="xMidYMid meet">
    <g app-blank-goban
       id="blank-goban"
       [width]="width()"
       [height]="height()"
       (clickCallBack)="onClick($event)"/>
    @for (coordAndContent of state().getPlayerCoordsAndContent(); track coordAndContent.coord.toString()) {
        <circle (click)="onClick(coordAndContent.coord)"
                id="piece-{{ coordAndContent.coord.x }}-{{ coordAndContent.coord.y }}"
                [attr.cx]="(SPACE_SIZE * 0.5) + (SPACE_SIZE * coordAndContent.coord.x)"
                [attr.cy]="(SPACE_SIZE * 0.5) + (SPACE_SIZE * coordAndContent.coord.y)"
                [attr.r]="SPACE_SIZE * 0.44"
                [ngClass]="getSpaceClass(coordAndContent.coord)"
                class="base"/>
    }
    @for (capture of captured; track capture.toString()) {
        <circle id="capture-{{ capture.x }}-{{ capture.y }}"
                (click)="onClick(capture)"
                [attr.cx]="(SPACE_SIZE * 0.5) + (SPACE_SIZE * capture.x)"
                [attr.cy]="(SPACE_SIZE * 0.5) + (SPACE_SIZE * capture.y)"
                [attr.r]="SPACE_SIZE * 0.14"
                class="captured-fill"/>
    }
</svg>
